import httpService from "./httpService";

export default {
  saveChoChuyenXuLy(form, id) {
    return httpService.post("vbIncomingChoCxlProcess/saveChoChuyenXuLy/" + id, form);
  },

  findAllByDocId(docId) {
    return httpService.get("vbIncomingChoCxlProcess/findAllByDocId",
      {params: {docId: docId}}
    )
  }
};



// WEBPACK FOOTER //
// ./src/services/vbIncomingChoCxlProcessService.js